module.exports = __webpack_public_path__ + "img/man-head-back.72e39759.png";